<template>
  <div>
    <label>{{ title }}</label>
    <div>
      <el-select
        clearable
        :value="value"
        class="select-info"
        size="large"
        @input="$emit('input', $event)"
      >
        <el-option
          v-for="option in selects.roles"
          :value="option.value"
          :label="option.label"
          :key="option.value"
          class="select-info"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectRole',
  props: ['value', 'title'],
  data() {
    return {
      selects: {
        simple: '',
        roles: [
          {
            key: 'key',
            value: 'value',
          },
        ],
      },
    };
  },
  created() {
    this.fetchData();
    this.selects.simple = this.value;
  },
  methods: {
    fetchData() {
      return this.$http
        .get(`${process.env.VUE_APP_ANNUAIRE_API_URL}/roleEntities`)
        .then(response => {
          this.selects.roles = response.data._embedded.roleEntities.map(
            entity => ({
              value: entity.roleId,
              label: entity.roleName,
            }),
          );
        });
    },
  },
};
</script>

<style>
.form-group2 {
  margin-bottom: 10px;
}
.el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
  color: #66615b;
  background-color: lightgray;
  border: #66615b;
}
</style>
